import HTTP from "owp.http";
import { BasePath } from "@gss/common/BasePath";
import type { NewsPost, NewsPostNew } from "./news.types";

let newsService: HTTP;

export const DAO = {
    init(): void {
        const restService = new HTTP(BasePath.rest());
        newsService = restService.path("news");
    },

    news: {
        async get(): Promise<NewsPost[]> {
            const r = await newsService.get();
            return r.json<NewsPost[]>();
        },
        async update(post: NewsPost): Promise<void> {
            await newsService.put({ json: post });
        },
        async add(post: NewsPostNew): Promise<void> {
            await newsService.post({ json: post });
        },
    },
};
